import { ConfirmDialog } from '@components/tailwind-components/ConfirmDialog';
import type React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  isOpen: boolean;
  isSaving: boolean;
  onSave: () => void;
  onDiscard: () => void;
  onCancel: () => void;
};

export const ConversationReviewUnsavedChangesPrompt: React.FC<Props> = ({
  isOpen,
  isSaving,
  onSave,
  onDiscard,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <ConfirmDialog
      isOpen={isOpen}
      icon='warning'
      title={t('train-ai.conversation-review.unsaved-changes.title')}
      description={t(
        'train-ai.conversation-review.unsaved-changes.description',
      )}
      onClose={onCancel}
      buttons={[
        {
          label: t('train-ai.conversation-review.unsaved-changes.save'),
          styling: 'primary',
          onClick: onSave,
          disabled: isSaving,
        },
        {
          label: t('general.buttons.cancel'),
          styling: 'cancel',
          onClick: onCancel,
          disabled: isSaving,
        },
        {
          label: t('train-ai.conversation-review.unsaved-changes.discard'),
          styling: 'outline-red',
          onClick: onDiscard,
          disabled: isSaving,
        },
      ]}
    />
  );
};
